import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=31b8a05a&scoped=true&"
import script from "./Webhooks.vue?vue&type=script&lang=ts&"
export * from "./Webhooks.vue?vue&type=script&lang=ts&"
import style0 from "./Webhooks.vue?vue&type=style&index=0&id=31b8a05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8a05a",
  null
  
)

export default component.exports